import { useNavigate } from 'react-router-dom';
import useCreate from '../useCreate';
import toast from 'react-hot-toast';

const useCreateUpdateBanner = ({ reset }) => {
  const navigate = useNavigate();

  const { setDataToServer } = useCreate({
    url: 'banner/create_update',
    refreshUrl: 'banner/list',
    onSuccess: () => {
      reset?.();
      toast.success("Banner Saved Successfully", {
        position: "top-right",
        duration: 3000
      });
      navigate('/masters/banners');
    }
  });

  const handleSubmit = (data) => {
    setDataToServer.mutate(data);
  };

  return { handleSubmit };
};

export default useCreateUpdateBanner;
